var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProjects(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 25.875 25.875",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M25.3125 0H14.625C14.3156 0 14.0625 0.253125 14.0625 0.5625V11.25C14.0625 11.5594 14.3156 11.8125 14.625 11.8125H25.3125C25.6219 11.8125 25.875 11.5594 25.875 11.25V0.5625C25.875 0.253125 25.6219 0 25.3125 0ZM23.4844 9.42188H16.4531V2.39062H23.4844V9.42188ZM11.25 14.0625H0.5625C0.253125 14.0625 0 14.3156 0 14.625V25.3125C0 25.6219 0.253125 25.875 0.5625 25.875H11.25C11.5594 25.875 11.8125 25.6219 11.8125 25.3125V14.625C11.8125 14.3156 11.5594 14.0625 11.25 14.0625ZM9.42188 23.4844H2.39062V16.4531H9.42188V23.4844ZM11.25 0H0.5625C0.253125 0 0 0.253125 0 0.5625V11.25C0 11.5594 0.253125 11.8125 0.5625 11.8125H11.25C11.5594 11.8125 11.8125 11.5594 11.8125 11.25V0.5625C11.8125 0.253125 11.5594 0 11.25 0ZM9.42188 9.42188H2.39062V2.39062H9.42188V9.42188ZM25.3125 14.0625H14.625C14.3156 14.0625 14.0625 14.3156 14.0625 14.625V25.3125C14.0625 25.6219 14.3156 25.875 14.625 25.875H25.3125C25.6219 25.875 25.875 25.6219 25.875 25.3125V14.625C25.875 14.3156 25.6219 14.0625 25.3125 14.0625ZM23.4844 23.4844H16.4531V16.4531H23.4844V23.4844Z",
    fill: "var(--fill-0, #1890FF)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjects);
export default __webpack_public_path__ + "static/media/projects.be09989461e8cb74d13aa85e88ebfa5a.svg";
export { ForwardRef as ReactComponent };